import React from "react";
import "../styles/Footer.css";
import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { courseCatalog } from "../data/courseDetails";
import {
  CONTACT_EMAIL,
  CONTACT_LOCATION,
  CONTACT_PHONE_DISPLAY,
  SOCIAL_LINKS,
} from "../data/contactConfig";

export default function Footer({ navigate }) {
  const goTo = (e, path) => {
    e.preventDefault();
    if (navigate) navigate(path);
    else {
      window.history.pushState({}, "", path);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-card">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-brand-header">
              <div className="footer-logo-wrap">
                <img src="/images/c3-logo.png" alt="Confideo Cloud & Code" className="footer-logo" />
              </div>
              <div className="footer-brand-titles">
                <h2>Confideo Cloud & Code</h2>
                <p className="footer-tagline">Learn. Build. Deploy. Grow.</p>
              </div>
            </div>
            <p className="footer-brand-desc">
              Empowering learners with practical DevOps and cloud training,
              hands-on projects, and career guidance.
            </p>

            <div className="footer-socials">
              <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer" className="whatsapp" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
              <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noreferrer" className="linkedin" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noreferrer" className="youtube" aria-label="YouTube">
                <FaYoutube />
              </a>
              <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="instagram" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h3>Quick Links</h3>
            <a href="/" onClick={(e) => goTo(e, "/")}>Home</a>
            <a href="/courses" onClick={(e) => goTo(e, "/courses")}>All Courses</a>
            <a href="/about" onClick={(e) => goTo(e, "/about")}>About Us</a>
            <a href="/reviews" onClick={(e) => goTo(e, "/reviews")}>Success Stories</a>
            <a href="/faq" onClick={(e) => goTo(e, "/faq")}>FAQ</a>
          </div>

          <div className="footer-col">
            <h3>Top Courses</h3>
            {courseCatalog.slice(0, 4).map((c) => (
              <a key={c.slug} href={`/courses/${c.slug}`} onClick={(e) => goTo(e, `/courses/${c.slug}`)}>
                {c.cardTitle}
              </a>
            ))}
          </div>

          <div className="footer-col">
            <h3>Contact</h3>
            <p>{CONTACT_LOCATION}</p>
            <p>
              <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer">{CONTACT_PHONE_DISPLAY}</a>
            </p>
            <p>
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 Confideo IT Services. All rights reserved.</p>
          <p>
            <a href="/privacy-policy" onClick={(e) => goTo(e, "/privacy-policy")}>
              Privacy Policy
            </a>
            <a href="/terms" onClick={(e) => goTo(e, "/terms")}>
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
